const factors = [
  {
    icon: 'ri-ruler-line',
    title: 'Ölçü ve Malzeme Etkisi',
    desc: 'Lightbox boyutu ve kasa malzemesi (alüminyum / plastik profil) fiyatın en belirleyici faktörleridir. LED kalitesi de maliyet üzerinde doğrudan etkilidir.',
  },
  {
    icon: 'ri-contrast-2-line',
    title: 'İç Mekan ve Dış Mekan Farkı',
    desc: 'IP65 sertifikalı dış mekan modeller, yağmur ve UV koruması gerektirdiğinden iç mekâna kıyasla daha yüksek fiyatlıdır. Kullanım yerine göre doğru model seçimi maliyet optimizasyonu sağlar.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Montaj ve Nakliye Unsurları',
    desc: 'İzmir içi ücretsiz keşif hizmetimiz mevcuttur. Montaj ve nakliye ücretleri projenin konumuna ve büyüklüğüne göre belirlenir.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Toplu Sipariş Avantajı',
    desc: '5 adetin üzerindeki siparişlerde birim fiyatta önemli indirim uygulanır. Reklam ajansları ve zincir markalar için özel toplu sipariş fiyatları mevcuttur.',
  },
];

export default function Pricing() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Sol – Başlık + CTA */}
          <div className="lg:sticky lg:top-24">
            <div className="inline-flex items-center gap-2 text-red-600 text-sm font-semibold uppercase tracking-widest mb-4">
              <span className="w-8 h-0.5 bg-red-600 inline-block"></span>
              Fiyatlandırma
            </div>
            <h2 className="text-4xl font-black text-gray-900 leading-tight mb-5">
              Lightbox Fiyatları <br />
              <span className="text-red-600">Nasıl Belirlenir?</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              Lightbox fiyatı; boyut, malzeme kalitesi, baskı türü ve montaj gereksinimlerine göre değişir.
              Rekabetçi fiyatlarla standart ve özel üretim yapıyoruz. Reklamcılara özel toplu sipariş indirimleri mevcuttur.
            </p>
            <div className="bg-red-50 border border-red-100 rounded-2xl p-6 mb-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-red-600 rounded-lg flex-shrink-0">
                  <i className="ri-price-tag-3-line text-white text-lg"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">Ücretsiz Keşif ve Teklif</div>
                  <div className="text-gray-600 text-sm">İzmir ve çevre illerde ücretsiz keşif hizmeti. Ölçü ve bilgilerinizi paylaşmanız durumunda 24 saat içinde size özel fiyat teklifi hazırlıyoruz.</div>
                </div>
              </div>
            </div>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-7 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
            >
              Fiyat Teklifi Al
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Sağ – Faktörler */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {factors.map((f) => (
              <div key={f.title} className="flex gap-4 p-5 bg-gray-50 rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center bg-red-100 rounded-lg flex-shrink-0 mt-0.5">
                  <i className={`${f.icon} text-red-600 text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm mb-1">{f.title}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
